import axios from 'axios'
import {withRouter, Redirect} from 'react-router-dom'
import React, { useState } from 'react'
import { Form, NavDropdown, Row } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { toast } from 'react-toastify'
import { enStyle } from '../../style/enStyle'
import { faStyle } from '../../style/faStyle'
import './style.scss'
import { useDispatch } from 'react-redux'
import { fetchCsrfCookie } from '../../redux/action/csrf/csrf-cookie'
import { get_user } from '../../redux/action/login/get_user'
import SimpleReactValidator from 'simple-react-validator';
import { useRef } from 'react'

const Login = ({history}) => {
    const [btnLoading, setBtnLoading] = useState(false)
    const [mainLogin, setMainLogin] = useState(true)
    const [twoStep, setTwoStep] = useState(false)
    const [forceUpdate, setForceUpdate] = useState(false)
    const [username, setUsername] = useState("")
    const [password, setPassword] = useState("")

    const [twoStepVerification, setTwoStepVerification] = useState("")
    const [useRecoveryCode, setUseRecoveryCode] = useState(false)
    const {t, i18n} = useTranslation();
    let userdata = JSON.parse(localStorage.getItem("user"))
    let dispatch = useDispatch()

    const handleNameChange = (e) => { setUsername(e.target.value) }
    const handlePassChange = (e) => { setPassword(e.target.value) }
    const handletwoStepVerificationChange = (e) => { setTwoStepVerification(e.target.value) }

    const changeLangToFa = () => { localStorage.setItem("lang", "fa"); i18n.changeLanguage("fa"); faStyle() }
    const changeLangToEn = () => { localStorage.setItem("lang", "en"); i18n.changeLanguage("en"); enStyle() }
    const changeLangToAr = () => { localStorage.setItem("lang", "ar"); i18n.changeLanguage("ar"); faStyle() }

    const reset = () => {
        setUsername("")
        setPassword("")
        setTwoStepVerification("")
    }

    const validator = useRef(new SimpleReactValidator({
        messages: {
          required:"پر کردن این فیلد الزامی است"
        },
    }))

    const handleFromSubmit = (e) => {
        e.preventDefault()
        const user = {username, password}
        dispatch(fetchCsrfCookie())
        setBtnLoading(true)
        toast.info(t("toast_check_info") , {position: 'bottom-right',className: 'foo-bar'})
        if (validator.current.allValid()) {
            axios.post('auth/login', user, {withCredentials: true})
            .then(res => {
                setBtnLoading(false)
                if(res.data.two_factor) {
                    setTwoStep(true)
                    setMainLogin(false)
                    localStorage.setItem("two_factor", "true")
                    toast.dismiss()
                    toast.info(`${t("toast_has_twofactor")}` , {position: 'bottom-right',className: 'foo-bar'})
                } else {
                    axios.get('auth/user')
                    .then( res => {
                        dispatch(get_user(res.data))
                        localStorage.setItem("user", JSON.stringify(res.data))
                        // localStorage.setItem("lang", "fa")
                        localStorage.setItem("two_factor", "false")
                        history.push("/dashboard")
                        toast.dismiss()
                        toast.success(`${t("toast_loggedIn")}` , {position: 'bottom-right',className: 'foo-bar'})
                    })
                    .catch(err => console.log(err))
                }
            })
            .catch(err => {
                setBtnLoading(false)
                if(err.response) {
                    if(err.response.status === 422 ) {
                        toast.dismiss()
                        toast.error(t("toast_wrong_data_entry") , {position: 'bottom-right',className: 'foo-bar'})
                    } else if ( err.response.status === 403 ) {
                        toast.dismiss()
                        toast.error(t("toast The user is blocked") , {position: 'bottom-right',className: 'foo-bar'})
                    } else {
                        toast.dismiss()
                        toast.error(t("toast_something_went_wrong") , {position: 'bottom-right',className: 'foo-bar'})
                    }
                }
            })
        } else {
            setBtnLoading(false)
            setForceUpdate(1)
            validator.current.showMessages()
            toast.dismiss()
            toast.error(t("toast_please_fill_in_all_fields") , {position: 'bottom-right',className: 'foo-bar'})
        }
    }

    const handleTowstepFromSubmit = (e) => {
        e.preventDefault()
        setBtnLoading(true)
        let data = useRecoveryCode ? {recovery_code: twoStepVerification} : {code: twoStepVerification}
        toast.info(t("toast_check_info") , {position: 'bottom-right',className: 'foo-bar'})
        dispatch(fetchCsrfCookie())
        axios.post('user/two-factor-challenge',data ,{withCredentials: true})
        .then(res => {
            setBtnLoading(false)
            axios.get('auth/user')
                .then( res => {
                    dispatch(get_user(res.data))
                    localStorage.setItem("user", JSON.stringify(res.data))
                    // localStorage.setItem("lang", "fa")
                    history.push("/dashboard")
                    toast.dismiss()
                    toast.success(`${t("toast_loggedIn")}` , {position: 'bottom-right',className: 'foo-bar'})
                })
        })
        .catch(err => {
            setBtnLoading(false)
            console.log(err)
            if(err.response && err.response.status === 422) {
                reset()
                setMainLogin(true)
                setTwoStep(false)
                toast.error(`${t("wrong_two_step_verification_code")}` , {position: 'bottom-right',className: 'foo-bar'})
            }
        })

    }

    if (userdata) {
        return <Redirect to="/dashboard" />
    } else {
        if(mainLogin === true) {
            return (
                <div className="login">
                    <div className='loginLang'>
                        <NavDropdown title={t("lang")} id="authlang">
                            <h6 onClick={changeLangToFa}><img src="/assets/img/icons/fa.png" alt="fa" />{t("fa")}</h6>
                            <h6 onClick={changeLangToEn}><img src="/assets/img/icons/en.png" alt="en" />{t("en")}</h6>
                            <h6 onClick={changeLangToAr}><img src="/assets/img/icons/ar.png" alt="ar" />{t("ar")}</h6>
                        </NavDropdown>
                    </div>
                    <Row>
                        <div className="col-lg-6 p-0">
                            <div className="login-image">
                                <img src="./assets/img/3.jpg" alt="login" className="login-bg" />
                                <div className="login-content ">
                                    <h2 className='animate__animated animate__fadeInDown'> {t("login_content_title")} </h2>
                                    <p className='animate__animated animate__fadeInDown'>
                                        {t("login_content_info_1")}<br/>
                                        {t("login_content_info_2")}<br />
                                        {t("login_content_info_3")}
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6 p-0">
                            <div className="login-form">
                                <div className="segment">
                                    <h1>{t("login")}</h1>
                                    <p> {t("login_page_subtitle")} </p>
                                </div>
                                <Form >
                                    <label>
                                        <input type="text" name="username" placeholder={t("username")} value={username} onChange={handleNameChange}/>
                                        <span className='validator_error'>{validator.current.message('username', username, 'required')}</span>
                                    </label>
                                    <label>
                                        <input type="password" name="password" placeholder={t("password")} value={password} onChange={handlePassChange} />
                                        <span className='validator_error'>{validator.current.message('password', password, 'required')}</span>
                                    </label>
                                    <button disabled={btnLoading ? true : false} className={btnLoading ? 'green btn-disabled' : 'green'} type="button" onClick={handleFromSubmit}>{t("login")}</button>
                                </Form>
                                <div className="text-center mt-4 forget_your_password">
                                    {t("forget_your_password")} <Link to="/forget-password">{t("forger_password")}</Link>
                                </div>
                                <div className="text-center mt-1 forget_your_password">
                                    {t("not_registered")} <Link to="/Register">{t("register")}</Link>
                                </div>
                            </div>
                        </div>
                    </Row>
                </div>
            )
        } else if (twoStep) {
            return (
                <div className="login">
                    <div className='loginLang'>
                        <NavDropdown title={t("lang")} id="lang">
                            <h6 onClick={changeLangToFa}><img src="/assets/img/icons/fa.png" alt="fa" />{t("fa")}</h6>
                            <h6 onClick={changeLangToEn}><img src="/assets/img/icons/en.png" alt="en" />{t("en")}</h6>
                            <h6 onClick={changeLangToAr}><img src="/assets/img/icons/ar.png" alt="ar" />{t("ar")}</h6>
                        </NavDropdown>
                    </div>
                    <Row>
                        <div className="col-lg-6 p-0">
                            <div className="login-image">
                                <img src="./assets/img/3.jpg" alt="login" className="login-bg" />
                                <div className="login-content ">
                                    <h2 className='animate__animated animate__fadeInDown'> {t("login_content_title")} </h2>
                                    <p className='animate__animated animate__fadeInDown'>
                                        {t("login_content_info")}
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6 p-0">
                            <div className="login-form">
                                <div className="segment">
                                    <h1>{t("two-step-verification-code")}</h1>
                                    <p> {t("two-step-verification-info")} </p>
                                </div>
                                <Form>
                                    <label>
                                        <input type="password" name="twoStepVerificationCode" placeholder={t("two-step-verification-code")} value={twoStepVerification} onChange={handletwoStepVerificationChange} />
                                    </label>
                                    <Form.Group className="mb-3" controlId="formBasicCheckbox" id="formCheckbox">
                                        <Form.Check type="checkbox" label={t("use_recovery_code")} value={useRecoveryCode} name="useRecoveryCode" onChange={() => setUseRecoveryCode(!useRecoveryCode)} />
                                    </Form.Group>
                                    <button className={btnLoading ? 'green btn-disabled' : 'green'} disabled={btnLoading ? true : false} type="button" onClick={handleTowstepFromSubmit}>{t("send")}</button>
                                </Form>
                            </div>
                        </div>
                    </Row>
                </div>
            )
        }
    }
}

export default withRouter(Login)
